var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclePlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9902 21.0469C16.5273 21.0469 21.0977 16.4766 21.0977 10.9492C21.0977 5.42188 16.5176 0.851562 10.9805 0.851562C5.45312 0.851562 0.892578 5.42188 0.892578 10.9492C0.892578 16.4766 5.46289 21.0469 10.9902 21.0469ZM10.9707 15.5C10.375 15.5 10.0137 15.0703 10.0137 14.4551V11.916H7.31836C6.71289 11.916 6.26367 11.5547 6.26367 10.9688C6.26367 10.3633 6.69336 9.99219 7.31836 9.99219H10.0137V7.30664C10.0137 6.69141 10.375 6.26172 10.9707 6.26172C11.5664 6.26172 11.9473 6.67188 11.9473 7.30664V9.99219H14.6523C15.2773 9.99219 15.6973 10.3633 15.6973 10.9688C15.6973 11.5547 15.2676 11.916 14.6523 11.916H11.9473V14.4551C11.9473 15.0898 11.5664 15.5 10.9707 15.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusIcon);
export default __webpack_public_path__ + "static/media/circlePlusIcon.6d870c10.svg";
export { ForwardRef as ReactComponent };